import { render } from "./MobileLanguageSelector.vue?vue&type=template&id=69e87aca"
import script from "./MobileLanguageSelector.vue?vue&type=script&lang=js"
export * from "./MobileLanguageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__